module.exports = __webpack_public_path__ + "img/vue-nuxt.06fae867.svg";